import { Box } from '@aviatrix/flights';
import React, { useEffect } from 'react';

type PerfetchImagesProps = {
    urls:string[]
}

const PerfetchImages = ({urls}:PerfetchImagesProps)=>{
    
    useEffect(()=>{

    },[urls])
    
    return (
        <>
        <Box sx={{display:'none'}}>
            {urls && urls.map((url:string, index:number)=>(
                <img src={url}  key={index}/>
            ))}
        </Box>
        </>
    )
}

export default PerfetchImages;